"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowSchema = exports.flowInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
exports.flowInitialized = {
    flowMeter: {},
    flowCircles: 0,
    flowCirclesAllowed: 0,
    mlPoured: 0,
    actualMlPoured: null,
    constantUsed: 0,
    price330Ml: 0,
    priceToPay: 0,
    timestamp: 0,
    drink: "",
    isTest: false,
    accessLog: null
};
exports.flowSchema = joi_1.default.object({
    flowMeter: joi_1.default.any(),
    flowCircles: joi_1.default.any(),
    flowCirclesAllowed: joi_1.default.any(),
    timestamp: joi_1.default.number(),
    mlPoured: joi_1.default.any(),
    actualMlPoured: joi_1.default.any(),
    price330Ml: joi_1.default.any(),
    priceToPay: joi_1.default.any(),
    constantUsed: joi_1.default.any(),
    isTest: joi_1.default.any(),
    drink: joi_1.default.any(),
    accessLog: joi_1.default.any(),
});
